/* global BigInt */
function integer(value) {
  if (value == null || value === "") return null;
  try {
    const n = BigInt(value);
    return n >= BigInt(0) ? n : null;
  } catch {
    return null;
  }
}

export function formatDatasetBytes(value) {
  const n = integer(value);
  if (n === null) return "Size unknown";
  const units = ["B", "KiB", "MiB", "GiB", "TiB", "PiB", "EiB"];
  let divisor = BigInt(1),
    unit = 0;
  while (unit < units.length - 1 && n >= divisor * BigInt(1024)) {
    divisor *= BigInt(1024);
    unit += 1;
  }
  if (!unit) return `${n.toString()} B`;
  const tenths = (n * BigInt(10) + divisor / BigInt(2)) / divisor;
  return `${tenths / BigInt(10)}${tenths % BigInt(10) ? `.${tenths % BigInt(10)}` : ""} ${units[unit]}`;
}

export function usageLabel(value) {
  const count = integer(value) ?? BigInt(0);
  return `${count.toLocaleString("en-US")} ${count <= BigInt(1) ? "use" : "uses"}`;
}

export function generationLabel(dataset) {
  return dataset.active_generation_id && dataset.generation_number != null
    ? `Generation ${dataset.generation_number}`
    : "Generation unavailable";
}

export function datasetBrowsePath(dataset) {
  // Imported generations use this directory alias. Managed generation browsing
  // must switch to utility-backend ID resolution before clone updates launch.
  const alias = dataset?.mount_alias;
  return dataset?.reader_available &&
    dataset?.active_generation_id &&
    typeof alias === "string" &&
    /^[a-z0-9]+(-[a-z0-9]+)*$/.test(alias)
    ? alias
    : null;
}

export function datasetDate(value) {
  if (!value) return "Not available";
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? "Not available" : date.toLocaleString();
}

// Work on a copy: filtering the display must not mutate the catalog used by
// the detail drawer. Unknown numeric/date values sort last in descending order.
export function filterAndSortDatasets(datasets, query, sortBy) {
  const search = query.trim().toLocaleLowerCase();
  const titleOrder = (a, b) =>
    String(a.title || "").localeCompare(String(b.title || ""), undefined, {
      sensitivity: "base",
      numeric: true,
    }) || String(a.id).localeCompare(String(b.id));
  const value = (d) => {
    if (sortBy === "size") return integer(d.measured_bytes);
    if (sortBy === "generation")
      return d.active_generation_id ? integer(d.generation_number) : null;
    if (sortBy === "updated") {
      const time = d.updated_at ? Date.parse(d.updated_at) : NaN;
      return Number.isFinite(time) ? time : null;
    }
    return null;
  };
  return datasets
    .filter((d) =>
      String(d.title || "")
        .toLocaleLowerCase()
        .includes(search),
    )
    .sort((a, b) => {
      if (sortBy === "name") return titleOrder(a, b);
      const av = value(a),
        bv = value(b);
      if (av === null && bv !== null) return 1;
      if (bv === null && av !== null) return -1;
      if (av !== null && bv !== null && av !== bv) return av > bv ? -1 : 1;
      return titleOrder(a, b);
    });
}
